import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_3 = { class: "text-xs italic text-gray-500 whitespace-nowrap m-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 whitespace-nowrap" }, "Kế hoạch SC", -1)
const _hoisted_5 = {
  key: 1,
  class: "mb-0 break-word"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Toa Xe", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Nhóm T.Xe", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Vào xưởng", -1)
const _hoisted_9 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Ra xưởng", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Ngày lập", -1)
const _hoisted_12 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Cấp sửa chữa", -1)
const _hoisted_14 = { class: "mb-0 break-word max-w-xs truncate" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, "Ngoài ĐM", -1)
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = {
  key: 0,
  class: "mb-0 text-muted text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationApproveDialog = _resolveComponent("ConfirmationApproveDialog")!
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentApprovalBienBan)
      ? (_openBlock(), _createBlock(_component_ConfirmationApproveDialog, {
          key: 0,
          "approve-type": "CONFIRM_BBGT",
          "is-display": _ctx.showConfirmDialog,
          "bien-ban-giai-the": _ctx.currentApprovalBienBan,
          onOnClose: _ctx.closeConfirmDialog,
          onOnConfirm: _ctx.handleConfirm
        }, null, 8, ["is-display", "bien-ban-giai-the", "onOnClose", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.currentApprovalBienBan)
      ? (_openBlock(), _createBlock(_component_ConfirmationApproveDialog, {
          key: 1,
          "approve-type": "APPROVE_BBGT",
          "is-display": _ctx.showApproveDialog,
          "bien-ban-giai-the": _ctx.currentApprovalBienBan,
          onOnClose: _ctx.closeApproveDialog,
          onOnConfirm: _ctx.handleApprove
        }, null, 8, ["is-display", "bien-ban-giai-the", "onOnClose", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.currentCompleteBienBan)
      ? (_openBlock(), _createBlock(_component_ConfirmHoanThanh, {
          key: 2,
          "bien-ban-data": _ctx.currentCompleteBienBan,
          show: _ctx.showCompleteDialog,
          onClose: _ctx.closeCompleteDialog,
          onConfirm: _ctx.handleComplete
        }, null, 8, ["bien-ban-data", "show", "onClose", "onConfirm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_table, {
        size: "medium",
        border: true,
        data: _ctx.bienBanItems,
        resizable: false,
        "empty-text": "Chưa có dữ liệu BBGT",
        class: "min-w-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "STT",
            "min-width": "60",
            "class-name": "text-left"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("small", null, "(" + _toDisplayString(scope.row.id) + ")", 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_word_break_column, {
            "header-title": "Số BBGT",
            property: "so_bien_ban",
            width: "250"
          }),
          (_ctx.isKeHoachColumnDisplaying)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                width: "300"
              }, {
                header: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx((scope) => [
                  (scope.row.ke_hoach_sua_chua)
                    ? (_openBlock(), _createBlock(_component_BaseLink, {
                        key: 0,
                        class: "mb-0 break-word max-w-sm truncate block text-blue-500 hover:underline",
                        to: {
              name: 'chi-tiet-ke-hoach-sua-chua',
              params: {
                id: scope.row.ke_hoach_sua_chua.id,
              },
            }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.ke_hoach_sua_chua?.ten_ke_hoach), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_5, "-"))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, { width: "300" }, {
            header: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_BaseLink, {
                class: "max-w-xs break-words block text-blue-500 hover:underline",
                to: {
              name: 'chi-tiet-toa-xe',
              params: {
                id: scope.row.toa_xe.id,
              },
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.toa_xe.danh_muc_toa_xe?.[0]?.ten_danh_muc || "-") + " - " + _toDisplayString(scope.row.toa_xe.ten_toa_xe) + " (" + _toDisplayString(scope.row.toa_xe.so_hieu) + ") ", 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          (_ctx.showNhomToaXeColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": "160"
              }, {
                header: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx((scope) => [
                  (_ctx.toaXeHasDmtx(scope.row.toa_xe))
                    ? (_openBlock(), _createBlock(_component_BaseLink, {
                        key: 0,
                        class: "max-w-xs truncate block text-blue-500 hover:underline",
                        to: {
              name: 'chi-tiet-danh-muc-toa-xe',
              params: {
                id: scope.row.toa_xe.danh_muc_toa_xe?.[0]?.id,
              },
            }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.toa_xe.danh_muc_toa_xe?.[0]?.ten_danh_muc || "-"), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "max-w-xs truncate block text-blue-500 hover:underline",
                        to: {
              name: 'danh-muc-toa-xe',
            }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("- ")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, { "min-width": "120" }, {
            header: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.moment(scope.row.ngay_vao_xuong).format("DD-MM-YYYY")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { "min-width": "120" }, {
            header: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                type: 
              _ctx.bienBanItems[scope.$index].ngay_ra_xuong ? 'danger' : 'warning'
            ,
                class: "mb-0 whitespace-nowrap"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.bienBanItems[scope.$index].ngay_ra_xuong
                ? _ctx.moment(_ctx.bienBanItems[scope.$index].ngay_ra_xuong).format(
                    "DD-MM-YYYY"
                  )
                : "Đang s/chữa"), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { "min-width": "120" }, {
            header: _withCtx(() => [
              _hoisted_11
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.moment(scope.row.ngay_lap).format("DD-MM-YYYY")), 1)
            ]),
            _: 1
          }),
          (_ctx.showCapSuaChuaColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "120"
              }, {
                header: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(scope.row.ke_hoach_sua_chua?.cap_sua_chua?.ten_cap_sc ||
              scope.row.cap_sua_chua?.ten_cap_sc), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "Xác nhận",
            "min-width": "60",
            "class-name": "text-center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.bienBanItems[scope.$index].is_approved,
                "onUpdate:modelValue": ($event: any) => ((_ctx.bienBanItems[scope.$index].is_approved) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Duyệt",
            "min-width": "60",
            "class-name": "text-center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.bienBanItems[scope.$index].is_admin_approved,
                "onUpdate:modelValue": ($event: any) => ((_ctx.bienBanItems[scope.$index].is_admin_approved) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { "min-width": "60" }, {
            header: _withCtx(() => [
              _hoisted_15
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.bienBanItems[scope.$index].has_dinh_muc_dong,
                "onUpdate:modelValue": ($event: any) => ((_ctx.bienBanItems[scope.$index].has_dinh_muc_dong) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Người tạo",
            "min-width": "140"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_16, _toDisplayString(scope.row.nguoi_dung?.ho_va_ten || "-"), 1),
              (scope.row.nguoi_dung?.so_dien_thoai)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(scope.row.nguoi_dung.so_dien_thoai), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.bienBanItems.length)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                width: "50",
                fixed: "right",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_Setting, {
                    actions: _ctx.getSettingActions(scope.row)
                  }, null, 8, ["actions"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ], 64))
}